/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
const isDevelopment = process.env.NODE_ENV === 'development';
const noop = () => {}; // placeholder function that does nothing

/**
 * `.bind` ensures the browser sees the call site, not this wrapper file.
 *
 * - `.debug`: prints statement in development but not in production
 * - `.info`: always prints the statement regardless of `NODE_ENV`
 */
export const logger = {
  debug: isDevelopment ? console.debug.bind(console) : noop,
  error: console.error.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
};
